/* eslint-disable react-refresh/only-export-components */
// Moved to @livingsyncs/ui (frontend split epic, Phase 2 Task 2.2). Shim kept
// so nothing importing the old path breaks during the transition.
// assumedRoleRef is a plain mutable-ref object, plain re-exported (a
// reference-copy const snapshot can read as undefined when this module and
// a direct @livingsyncs/ui import land in the same module graph — see the
// formErrorHandler.ts note). AssumedRoleProvider/useAssumedRole are real
// declarations, not reference copies — see hooks/useAuth.ts.
import * as _assumedRoleModule from "@livingsyncs/ui";
import type { ReactNode } from "react";

export { assumedRoleRef } from "@livingsyncs/ui";

export function AssumedRoleProvider({ children }: { children: ReactNode }) {
  const RealProvider = _assumedRoleModule.AssumedRoleProvider;
  return <RealProvider>{children}</RealProvider>;
}
export function useAssumedRole() {
  return _assumedRoleModule.useAssumedRole();
}
